// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603201408/js/" + chunkId + "." + {"44":"e2dbf3a8","225":"a8ce5464","481":"416b9174","486":"e97a62e8","770":"145f6d05"}[chunkId] + ".0.18426073321955605.chunk.js";
};